// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../home/tiger/.nvm/versions/node/v12.4.0/lib/node_modules/@ies/eden/node_modules/@ies/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1ps4ybiNxM0JIWSzJ0Vbha{width:3.34rem;height:5.64rem;display:inline-block;background:#e5e5e6;border-radius:4px}._2CwU38rd7XVHb6gbHSr2du{margin-bottom:.42rem}._1Crdr5TyDzsjqeRmomoYrI{border-radius:2px;background:#e5e5e6;height:.32rem}.XfASrWbot1ldO20DWys5r{margin-right:.1rem;border-radius:50%;background:#e5e5e6;width:.36rem;height:.36rem}._2nbBD294RnWeSsf_APW4qZ{flex-direction:column}._3gddfv-bFE4lhpWQ1qRZsV{margin-top:.1rem;display:flex;margin-bottom:.42rem}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": "_1ps4ybiNxM0JIWSzJ0Vbha",
	"skeleton-card": "_2CwU38rd7XVHb6gbHSr2du",
	"section": "_1Crdr5TyDzsjqeRmomoYrI",
	"square": "XfASrWbot1ldO20DWys5r",
	"column": "_2nbBD294RnWeSsf_APW4qZ",
	"info": "_3gddfv-bFE4lhpWQ1qRZsV"
};
module.exports = ___CSS_LOADER_EXPORT___;
